export const typeUi = {
    getTheme: '[theme] getTheme',
    getId: '[theme] getId',
    changeImg: '[theme] changeImg',
    removeTheme: '[theme] removeTheme',
    setImgPreview: '[theme] setImgPreview',
    setImgReload: '[theme] setImgReload',
}
